import React from "react";

const NotificationCards = ({ heading, email, sub, time, icon, linkURL }) => {
  return (
    <div className="notification-card-container">
      <div className="notification-cards">
        <div className="icon-area">
          <img src={icon} alt="msgList" />
        </div>
        <div className="msg-area">
          {linkURL ? (
            <h5>
              <a href={linkURL} style={{ color: 'inherit', textDecoration: 'underline', cursor: 'pointer' }}>
                {heading} <span style={{ fontWeight: 'bold' }}>&rarr;</span>
              </a>
            </h5>
          ) : (
            <h5>{heading}</h5>
          )}
          {email && <b className="email"> {email}</b>}
          {sub && <p className="sub">{sub} </p>}
        </div>
      </div>
      <div className="date-time">
        <p>{time}</p>
      </div>
    </div>
  );
};

export default NotificationCards;
